<template lang="pug">
#chart.container-fluid.p-0
  #scatter.desktop
  .legend.desktop
    .row.mx-0.d-flex.align-items-center.justify-content-end
      p.my-0.mx-2
        span.bold Periodistas
        | &nbsp;con contenido
        //.dot.mx-2.dark-full
        .dot.mx-2.full
    .row.mx-0.d-flex.align-items-center.justify-content-end
      p.my-0.mx-2 
        span.bold Periodistas
        | &nbsp;sin contenido
        //.dot.mx-2.dark-clear
        .dot.mx-2.clear
  b-modal#modal-intro.desktop(
    centered,
    scrollable,
    hide-header,
    hide-footer,
    size="lg"
  )
    template
      p.title ¿Qué es?
      p.text.text-justify Parece contraintuitivo, pero es cierto: desde que México transitó a la democracia, se ha convertido en uno de los países más peligrosos para ejercer el periodismo en el mundo. Entre 2000 y 2018, el número de reporteros y trabajadores de medios asesinados en el país llegó a 104, según información del Comité de Protección a Periodistas. De estos crímenes, 99% permanece impune; es decir, sin resolver.
      p.text.text-justify Ante esta crisis, muchos reporteros se estaban convirtiendo en cifras, estadísticas más de la violencia. Sus trabajos transitaban rápidamente al olvido. Por eso creamos
        span.large.bold DEFENSORES DE LA DEMOCRACIA
        | , un archivo viviente que conserva el trabajo de los periodistas asesinados en México.
      p.text.text-justify Cuando matan a un reportero, la pérdida es doble. No sólo perdemos a la persona, también perdemos su labor para siempre. Nos privan de esa documentación; de la denuncia crítica; de investigaciones e información con la que tomamos decisiones todos los días para seguir participando en el fortalecimiento de nuestra democracia.
      p.text.text-justify
        span.large.bold DEFENSORES DE LA DEMOCRACIA&nbsp;
        | es un espacio de y para todos, donde honramos su memoria y resguardamos nuestra historia.
  //.desktop.home-text
    b-button(v-b-modal.modal-intro) ¿Qué es?
  #scatter-mobile.mobile
    .row.row-year.mx-0.mb-0.mt-4
      .col-12.px-4
        p.text.text-justify Parece contraintuitivo, pero es cierto: desde que México transitó a la democracia, se ha convertido en uno de los países más peligrosos para ejercer el periodismo en el mundo. Entre 2000 y 2018, el número de reporteros y trabajadores de medios asesinados en el país llegó a 104, según información del Comité de Protección a Periodistas. De estos crímenes, 99% permanece impune; es decir, sin resolver.

        p.text.text-justify Ante esta crisis, muchos reporteros se estaban convirtiendo en cifras, estadísticas más de la violencia. Sus trabajos transitaban rápidamente al olvido. Por eso creamos
          span.large.bold DEFENSORES DE LA DEMOCRACIA
          | , un archivo viviente que conserva el trabajo de los periodistas asesinados en México.

        p.text.text-justify Cuando matan a un reportero, la pérdida es doble. No sólo perdemos a la persona, también perdemos su labor para siempre. Nos privan de esa documentación; de la denuncia crítica; de investigaciones e información con la que tomamos decisiones todos los días para seguir participando en el fortalecimiento de nuestra democracia.
        p.text.text-justify
          span.large.bold DEFENSORES DE LA DEMOCRACIA&nbsp;
          | es un espacio de y para todos, donde honramos su memoria y resguardamos nuestra historia.
      .col-12.px-4.mt-4.journalist
        .d-flex.my-2.align-items-center
          .dot.clear.mx-1
          p.mb-0 Periodistas sin contenido disponible
        .d-flex.my-2.align-items-center
          .dot.full.mx-1
          p.mb-0 Periodistas con contenido disponible

    .row.row-year.mx-0.d-flex.justify-content-center.my-2.px-3(
      v-for="year in years",
      v-bind:key="year",
      :data-year="year",
      v-if="journalistsKilledByYear[year].length > 0"
    )
      .col-12.mb-2.mt-4.px-1
        p.year.mb-0
          span {{ year % 5 == 0 ? year : '' }}

      .col-12.journalist
        .row
          .col-6.col-sm-4.mb-1(
            v-for="(journalist, index) in journalistsKilledByYear[year]",
            @click="selectJournalist(journalist, index)"
          ) 
            .dot.my-3(
              v-bind:class="[journalist.Publicaciones === 0 ? 'clear' : 'full']"
            )
            p {{ journalist.Nombre }}
              br
              span.accent-text Fecha de asesinato:
              br 
              span.accent-text {{ journalist['Fecha de asesinato'] }}
</template>

<script>
import * as d3 from "d3";
import * as _ from "lodash";

export default {
  name: "Scatter",
  data() {
    return {
      lista: [],
      years: [],
      journalistsKilledByYear: {},
    };
  },
  computed: {
    allJournalists() {
      return this.$store.state.allJournalists;
    },
    selectedJournalist: {
      get() {
        return this.$store.state.selectedJournalist;
      },
      set(newValue) {
        this.$store.state.selectedJournalist = newValue;
      },
    },
  },
  methods: {
    selectJournalist(journalist, i) {
      this.selectedJournalist = journalist;
      if (this.selectedJournalist.Publicaciones > 0) {
        window.scrollTo(0, 0);
        this.$router.push({
          path: `/periodista/${this.selectedJournalist.Nombre.split(" ").join(
            "-"
          )}`,
        });
      }
    },
    setData() {
      let minYear = Infinity;
      let maxYear = -Infinity;
      this.allJournalists.forEach((l) => {
        const year = Number(l["Fecha de asesinato"].slice(-4));
        if (year < minYear) minYear = year;
        if (year > maxYear) maxYear = year;
      });
      this.years = _.range(minYear, maxYear + 1);
      this.years.forEach((y) => {
        this.journalistsKilledByYear[y] = this.allJournalists.filter((l) =>
          l["Fecha de asesinato"].includes(y.toString())
        );
      });
    },
    async drawScatter() {
      d3.select("#scatter svg").remove();

      const margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      };
      const width = document.getElementById("chart").clientWidth - 30;
      const large = 1.6;
      const height = window.innerHeight * large; //680;
      const blockProportion = 0.7 / 1.5 - 0.04;
      const blockSize = window.innerHeight * 0.7;
      const startY = height * 0.2;
      const increaseY = startY / 6;
      const decreaseY = (height * 0.35) / 19;
      const paddingX = width / (this.years.length + 3);
      const paddingY = window.innerHeight / 14; //50;
      let countX = paddingX;
      let countY = paddingY;
      const radius = width > 500 ? 6 : 4;
      const accentYearSize = 35;
      const vm = this;

      const svg = d3
        .select("#scatter")
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom);

      const g = svg
        .append("g")
        .attr("transform", `translate(${margin.left},${margin.top})`);

      const line = g
        .selectAll(".line")
        .data(this.years)
        .enter()
        .append("g")
        .attr("class", (d) => (d == 2000 ? "line line-block" : "line"))
        .attr("id", (d) => "year-" + d);

      line
        .append("line")
        .attr("x1", (d) => {
          return (countX += paddingX);
        })
        .attr("y1", (d, i) => {
          countX = paddingX;
          if (d <= 2000) return startY - increaseY * i;
          else return 0 + decreaseY * (i - 6);
        })
        .attr("x2", (d) => {
          return (countX += paddingX);
        })
        .attr("y2", (d) => height)
        .attr("year", (d) => d)
        .attr("stroke-width", (d) => (d == 2000 ? 13 : 1))
        .attr("stroke", (d) =>
          d == 2000 ? "#141414" : d % 5 == 0 ? "#b8b8b8" : "#e6e6e6"
        );

      line
        .append("text")
        .attr("x", function (d) {
          return d == 2000
            ? -height + window.innerHeight * 0.95
            : height * blockProportion -
                parseInt(d3.select(this.parentNode).select("line").attr("y2"));
        })
        .attr("y", function (d) {
          return (
            parseInt(d3.select(this.parentNode).select("line").attr("x1")) -
            radius * 2
          );
        })
        .attr("text-anchor", "end")
        .attr("dominant-baseline", "baseline")
        .style("font-size", (d) => (d == 2000 ? accentYearSize : 18))
        .attr("transform", "rotate(-90)")
        .text((d) => (d % 5 == 0 ? d : ""));

      const block = g
        .append("rect")
        .attr("class", "block")
        .attr(
          "transform",
          `translate(-${margin.left},${margin.top + height - blockSize})`
        )
        .attr("width", d3.select(".line-block line").attr("x1"))
        .attr("height", blockSize)
        .style("fill", "#141414");

      // set legend postion
      d3.select(".legend").node().style.left =
        d3.select(".line-block line").attr("x1") - 265 + "px";

      d3.selection.prototype.moveToFront = function () {
        return this.each(function () {
          this.parentNode.appendChild(this);
        });
      };

      const circles = g
        .selectAll(".circles")
        .data(this.years)
        .enter()
        .append("g")
        .attr("class", "circles");

      circles
        .selectAll("circle")
        .data((d) => vm.journalistsKilledByYear[d])
        .enter()
        .append("circle")
        .attr("class", "circle")
        .attr("cx", (d) => {
          if (d["Fecha de asesinato"].includes("/")) {
            return d3
              .select(
                "#year-" +
                  d["Fecha de asesinato"].substring(
                    d["Fecha de asesinato"].length - 4
                  )
              )
              .select("line")
              .attr("x1");
          } else {
            return d3
              .select("#year-" + d["Fecha de asesinato"].slice(-4))
              .select("line")
              .attr("x1");
          }
        })
        .attr("cy", (d, i) => {
          let year;
          if (d["Fecha de asesinato"].includes("/")) {
            year = d["Fecha de asesinato"].substring(
              d["Fecha de asesinato"].length - 4
            );
          } else {
            year = d["Fecha de asesinato"].slice(-4);
          }
          const qtyPerYear = vm.journalistsKilledByYear[year].length;
          return (
            i * paddingY + (height - (qtyPerYear - 1) * paddingY) / 2 + startY
          );
        })
        .attr("r", radius)
        .attr("fill", (d) => {
          let year;
          if (d["Fecha de asesinato"].includes("/")) {
            year = d["Fecha de asesinato"].substring(
              d["Fecha de asesinato"].length - 4
            );
          } else {
            year = d["Fecha de asesinato"].slice(-4);
          }
          if (year > 2000) return "#920D00";
          else return "#913830";
        })
        .style("opacity", (d) => (d.Publicaciones === 0 ? 0.6 : 1))
        .on("click", (d, i) => {
          this.selectedJournalist = d;
          if (this.selectedJournalist.Publicaciones > 0) {
            this.$router.push({
              path: `/periodista/${this.selectedJournalist.Nombre.split(
                " "
              ).join("-")}`,
            });
          }
        })
        .on("mouseover", function (d, i) {
          d3.select(this)
            .attr("cx", () => {
              if (d3.select(this).attr("cx") < 70) return 70;
              if (Number.parseFloat(d3.select(this).attr("cx")) + 70 > width)
                return width - 70;
              return d3.select(this).attr("cx");
            })
            .attr("fill", (d) => {
              let year;
              if (d["Fecha de asesinato"].includes("/")) {
                year = d["Fecha de asesinato"].substring(
                  d["Fecha de asesinato"].length - 4
                );
              } else {
                year = d["Fecha de asesinato"].slice(-4);
              }
              if (year > 2000) return "#920D00";
              else return "#913830";
            })
            .attr("r", 80)
            .style("cursor", "pointer");

          const tooltip = d3
            .select(this.parentNode)
            .append("text")
            .attr("id", () => "t" + i)
            .attr("x", () => d3.select(this).attr("cx") - 52)
            .attr("y", () => d3.select(this).attr("cy") - 24)
            .style("fill", "white")
            .style("font-size", "13px")
            .style("pointer-events", "none")
            .text(() => {
              const totalNames = d.Nombre.split(" ");
              const name =
                (totalNames[0] ? totalNames[0] : "") +
                " " +
                (totalNames[1] ? totalNames[1] : "");
              return name;
            });

          tooltip
            .append("tspan")
            .attr("x", () => d3.select(this).attr("cx") - 52)
            .attr("y", () => d3.select(this).attr("cy") - 10)
            .text(() => {
              const totalNames = d.Nombre.split(" ");
              const name =
                (totalNames[2] ? totalNames[2] : "") +
                " " +
                (totalNames[3] ? totalNames[3] : "");
              return name;
            });
          tooltip
            .append("tspan")
            .attr("x", () => d3.select(this).attr("cx") - 52)
            .attr("y", () => Number.parseInt(d3.select(this).attr("cy")) + 10)
            .style("fill", "#000")
            .text("Fecha de asesinato");
          tooltip
            .append("tspan")
            .attr("x", () => d3.select(this).attr("cx") - 52)
            .attr("y", () => Number.parseInt(d3.select(this).attr("cy")) + 24)
            .style("fill", "#000")
            .text(() => {
              const date = d["Fecha de asesinato"];
              return date.length < 15 ? date : date.slice(0, 15);
            });
          tooltip
            .append("tspan")
            .attr("x", () => d3.select(this).attr("cx") - 52)
            .attr("y", () => Number.parseInt(d3.select(this).attr("cy")) + 38)
            .style("fill", "#000")
            .text(() => {
              const date = d["Fecha de asesinato"];
              return date.length < 15 ? "" : date.slice(15);
            });

          d3.select(this.parentNode).moveToFront();
        })
        .on("mouseout", function (d, i) {
          d3.select("#t" + i)
            .transition()
            .duration(50)
            .remove();

          d3.select(this)
            .transition()
            .duration(200)
            .attr("fill", "#920D00")
            .attr("r", radius)
            .attr("cx", (d) => {
              if (d["Fecha de asesinato"].includes("/")) {
                return d3
                  .select(
                    "#year-" +
                      d["Fecha de asesinato"].substring(
                        d["Fecha de asesinato"].length - 4
                      )
                  )
                  .select("line")
                  .attr("x1");
              } else {
                return d3
                  .select("#year-" + d["Fecha de asesinato"].slice(-4))
                  .select("line")
                  .attr("x1");
              }
            })
            .style("cursor", null);
        });
    },
    async initialize() {
      await this.setData();
      if (window.innerWidth >= 768) this.drawScatter();
      window.onresize = () => {
        if (window.innerWidth >= 768) this.drawScatter();
      };
    },
  },
  async mounted() {
    this.initialize();
  },
};
</script>

<style lang="scss">
#chart {
  background: none;
}

#scatter {
  .tooltip {
    background-color: #920d00;
    width: 140px;
    height: 140px;
    border-radius: 50%;
  }
}

.legend {
  position: absolute;
  bottom: 10px;
  color: #fff;
  width: 300px;
  font-size: 0.8rem;
  .dot {
    width: 0.8rem;
    height: 0.8rem;
    border-radius: 50%;
    &.clear {
      background-color: #920d00;
      opacity: 0.6;
    }
    &.full {
      background-color: #920d00;
      opacity: 1;
    }
    &.dark-clear {
      background-color: #913830;
      opacity: 0.6;
    }
    &.dark-full {
      background-color: #913830;
      opacity: 1;
    }
  }
}
.home-text button {
  position: absolute;
  bottom: 13%;
  left: 3%;
  border: 2px solid #fff;
  background-color: rgba(0, 0, 0, 0);
  width: 20%;
  font-family: "Barlow", sans-serif;
  border-radius: 3px;
}
#modal-intro {
  .modal-content {
    background-color: #000000ee;
    border-radius: 0px;
    color: white;
    padding: 15px;
    margin: 20px;
    .title {
      font-size: 30px;
    }
    .text,
    ul {
      font-size: 15px;
    }
  }
}
@media (max-width: 767.98px) {
  #chart {
    background: #fff;
  }
  #scatter-mobile {
    .row-year {
      width: 100%;
    }
    .year {
      border-top: 1px solid #7a7a7a;
      line-height: 0.1em;
      span {
        background: #fff;
        font-size: 2.5rem;
        padding: 0 1rem 0 0rem;
      }
    }
    .journalist {
      .dot {
        height: 1.2rem;
        width: 1.2rem;
        border-radius: 50%;
        background-color: #920d00;
        margin: auto;
        &.clear {
          opacity: 0.6;
        }
        &.full {
          opacity: 1;
        }
      }
      p {
        line-height: 1.1;
        font-size: 0.85rem;
      }
    }
  }
}
</style>